import { render, staticRenderFns } from "./bottomTar.vue?vue&type=template&id=120557c6&scoped=true&"
import script from "./bottomTar.vue?vue&type=script&lang=js&"
export * from "./bottomTar.vue?vue&type=script&lang=js&"
import style0 from "./bottomTar.vue?vue&type=style&index=0&id=120557c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120557c6",
  null
  
)

export default component.exports